import React from "react";
import "../AdminHeader/AdminHeader.css";
const AdminHeader = (props) => {
  return (
    <nav className="navbar navbar-expand-lg appHeaderAdmin">
      <div className="container"></div>
    </nav>
  );
};
export default AdminHeader;
